export default class Accordion {

    constructor() {
        if (this.accordionHeading = document.querySelectorAll(".accordion-heading")) {
            this._registerClicks()
        }
    }

    _registerClicks() {
        for (let i = 0, l = this.accordionHeading.length; i < l; i++) {
            this.accordionHeading[i].addEventListener("click", (e) => {
                e.stopPropagation()
                this.accordionHeading[i].classList.toggle("accordion-heading--active")
                this.accordionHeading[i].nextElementSibling.classList.toggle("accordion-content--active")
            })
        }
    }
}